"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BaseCarousel_1 = __importDefault(require("../base-carousel/BaseCarousel"));
var classnames_1 = __importDefault(require("classnames"));
var product_card_carousel_module_scss_1 = __importDefault(require("./product-card-carousel.module.scss"));
var DESKTOP_ITEMS_TO_SHOW = 5;
var MOBILE_ITEMS_TO_SHOW = 2;
var TABLET_ITEMS_TO_SHOW = 4;
var MAX_MOBILE_SIZE = 767;
var MAX_TABLET_SIZE = 1023;
var ALPHA_ProductCardCarousel = function (_a) {
    var _b;
    var id = _a.id, ariaLabel = _a.ariaLabel, heading = _a.heading, children = _a.children;
    var _c = (0, react_1.useState)(0), innerWidth = _c[0], setInnerWidth = _c[1];
    var _d = (0, react_1.useState)(false), display = _d[0], setDisplay = _d[1];
    var _e = react_1.default.useState(false), isReady = _e[0], setIsReady = _e[1];
    var calculateNumberOfItemsToShow = function (width) {
        if (width > MAX_TABLET_SIZE)
            return DESKTOP_ITEMS_TO_SHOW;
        if (width > MAX_MOBILE_SIZE)
            return TABLET_ITEMS_TO_SHOW;
        return MOBILE_ITEMS_TO_SHOW;
    };
    var _f = (0, react_1.useState)(calculateNumberOfItemsToShow(innerWidth)), numberOfItemsToShow = _f[0], setNumberOfItemsToShow = _f[1];
    var showPeek = function () {
        return innerWidth <= MAX_TABLET_SIZE;
    };
    var showNavigationButtons = function () {
        var numberOfProductCards = react_1.default.Children.count(children);
        return (numberOfProductCards > DESKTOP_ITEMS_TO_SHOW &&
            innerWidth > MAX_TABLET_SIZE);
    };
    var showVisibleScrollbar = function () {
        var numberOfProductCards = react_1.default.Children.count(children);
        return (innerWidth <= MAX_TABLET_SIZE ||
            (numberOfProductCards > DESKTOP_ITEMS_TO_SHOW &&
                innerWidth > MAX_TABLET_SIZE));
    };
    var handleResize = function () {
        // on initial render there is no window object (notably if server side rendered)
        var newInnerWidth = global.innerWidth || MAX_MOBILE_SIZE;
        var newNumberOfItemsToShow = calculateNumberOfItemsToShow(newInnerWidth);
        setDisplay(true);
        setInnerWidth(newInnerWidth);
        setNumberOfItemsToShow(newNumberOfItemsToShow);
    };
    (0, react_1.useEffect)(function () {
        handleResize();
    });
    // This is used to reduce the CLS of the carousel. On first render the client does
    // not know size of the carousel so the carousel is rendered with a min height of 400px (an estimated size).
    // Once rendered the client knows the size of the carousel we then set min height to 0px.
    (0, react_1.useEffect)(function () {
        if (isReady === false)
            setIsReady(true);
    }, [isReady]);
    return (react_1.default.createElement("div", { "data-testid": "product-card-carousel", className: (0, classnames_1.default)(product_card_carousel_module_scss_1.default['product-card-carousel'], (_b = {},
            _b[product_card_carousel_module_scss_1.default.ready] = isReady,
            _b)) }, display && (react_1.default.createElement(BaseCarousel_1.default, { id: id, heading: heading, numberOfItemsToShow: numberOfItemsToShow, showPips: false, showPeek: showPeek(), ariaLabel: ariaLabel, showNavigationButtons: showNavigationButtons(), showVisibleScrollbar: showVisibleScrollbar(), onResize: handleResize, hasPadding: true }, children))));
};
exports.default = ALPHA_ProductCardCarousel;
//# sourceMappingURL=ProductCardCarousel.js.map